import type { Difficulty } from '../types/game.types';

let selectedDifficulty: Difficulty = 'medium';

export function getDifficulty(): Difficulty {
  return selectedDifficulty;
}

export function setDifficulty(difficulty: Difficulty): void {
  selectedDifficulty = difficulty;
}
